import Swiper from 'swiper';
import { A11y } from 'swiper/modules';
import Modals from '../../components/Modals';

import 'swiper/css';

document.addEventListener('DOMContentLoaded', () => {
	if (!window.modals) {
		window.modals = new Modals();
		window.modals.init();
	}

	const sliderBlocks = document.querySelectorAll('.lnip-protege-tabs-block');

	sliderBlocks.forEach((block) => {
		const sliderEl = block.querySelector('.lnip-protege-tabs__swiper');
		const triggers = block.querySelectorAll('[data-tab-trigger]');

		const imgs = block.querySelectorAll('.lnip-protege-tab img');

		imgs.forEach((img) => {
			img.addEventListener('click', (event) => {
				event.preventDefault();

				window.modals.openImagePopup(
					img.currentSrc || img.src,
					img.alt || ''
				);
			});
		});

		if (!sliderEl || !triggers.length) {
			return;
		}

		const slidesPerView = Number(block.dataset.slidesPerView || 1);
		const spaceBetween = Number(block.dataset.spaceBetween || 24);
		const loop = block.dataset.loop === 'true';

		const swiper = new Swiper(sliderEl, {
			effect: 'slide',
			modules: [A11y],
			slidesPerView,
			spaceBetween,
			loop,
			autoplay: block.dataset.autoplay === 'true',
			autoHeight: true,
			allowTouchMove: true,
			speed: 500,
			on: {
				init(swiperInstance) {
					updateActiveTrigger(
						swiperInstance.realIndex ?? swiperInstance.activeIndex
					);
				},
				slideChange(swiperInstance) {
					updateActiveTrigger(
						swiperInstance.realIndex ?? swiperInstance.activeIndex
					);
				},
			},
		});

		function updateActiveTrigger(activeIndex) {
			triggers.forEach((trigger, index) => {
				const isActive = index === activeIndex;

				trigger.classList.toggle('is-active', isActive);
				trigger.setAttribute('aria-selected', isActive ? 'true' : 'false');
				trigger.setAttribute('tabindex', isActive ? '0' : '-1');
			});
		}

		triggers.forEach((trigger, index) => {
			trigger.addEventListener('click', () => {
				if (loop) {
					swiper.slideToLoop(index);
				} else {
					swiper.slideTo(index);
				}
			});

			trigger.addEventListener('keydown', (event) => {
				let nextIndex = null;

				if (event.key === 'ArrowRight') {
					nextIndex = index + 1 >= triggers.length ? 0 : index + 1;
				}

				if (event.key === 'ArrowLeft') {
					nextIndex = index - 1 < 0 ? triggers.length - 1 : index - 1;
				}

				if (event.key === 'Home') {
					nextIndex = 0;
				}

				if (event.key === 'End') {
					nextIndex = triggers.length - 1;
				}

				if (nextIndex !== null) {
					event.preventDefault();

					if (loop) {
						swiper.slideToLoop(nextIndex);
					} else {
						swiper.slideTo(nextIndex);
					}

					triggers[nextIndex].focus();
				}
			});
		});
	});
});